// apps/website/src/components/features/FeaturesPageSkeleton.tsx


export function FeaturesPageSkeleton() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
      {/* Sidebar Skeleton */}
      <div className="hidden lg:block lg:col-span-1">
        <div className="sticky top-24">
          <div className="h-10 bg-slate-100 border-2 border-black rounded-t-xl animate-pulse" />
          <div className="max-h-[calc(100vh-8rem)] overflow-hidden">
            <div className="h-[600px] bg-slate-100 border-x-2 border-b-2 border-black rounded-b-xl animate-pulse" />
          </div>
        </div>
      </div>

      {/* Grid Skeleton */}
      <div className="lg:col-span-3">
        <div className="h-10 w-3/4 bg-slate-200 rounded-lg animate-pulse mb-6" />
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {Array.from({ length: 9 }).map((_, i) => (
            <div key={i} className="h-48 bg-slate-100 border-2 border-black rounded-xl animate-pulse" />
          ))}
        </div>
      </div>
    </div>
  );
}
